
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import request from "@/lib/request/request";
import config from "@/config/config";
import gateway from "@/lib/request/gateway";
import _ from "lodash-es";
import Auth from "@/lib/common/auth";
import VirRequest, {
  VirImgListParam,
  VirImgList,
  VirSaveImgParam
} from "@/lib/model/vir/VirRequest";

@Component({})
export default class VirUploadImg extends Vue {
  @Prop({ default: "examLogoUrl", type: String }) private imgType!: string;
  @Prop({ default: "", type: String }) private img!: string;
  name = "vir-upload-img";
  loading = false;
  params = {};
  headers = {};
  imageUrl = "";
  virSaveImgParam = new VirSaveImgParam();

  get uploadUrl() {
    return _.trim(config.accountUrl) + "/api/common/uploadOss";
  }
  get token() {
    return Auth.token;
  }

  @Watch("img")
  onImgChange(val: string) {
    this.imageUrl = val;
  }

  saveImg() {
    VirRequest.virSaveImg(this.virSaveImgParam)
      .then(res => {
        console.log("saveImg res: ", res);
      })
      .then(() => {
        this.$emit("after-upload");
      });
  }

  uploadImg(data: { filename: string; file: File }) {
    const { filename, file } = data;
    this.loading = true;
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.loading = false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片过大!");
      this.loading = false;
    }
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
          })
          .finally(() => {
            this.imageUrl = tempUrl;
            this.virSaveImgParam.url = this.imageUrl;
            this.virSaveImgParam.companyId = parseInt(Auth.companyId);
            this.saveImg();
          });
      }
    });
  }
  error() {
    console.log("error");
  }
}
